import { FC } from "react";

interface TableTeamTitleProps {
    logoUrl?: string;
    name: string;
}

export const TableTeamTitle: FC<TableTeamTitleProps> = ({ logoUrl, name }) => {
    return (
        <div className="flex flex-row items-center gap-1 sm:gap-2 px-1 uppercase text-left">
            {logoUrl && <img className="block h-6 w-6 sm:h-12 sm:w-12 object-contain" src={logoUrl} />}
            <span className=" truncate">{name}</span>
        </div>
    );
}
